
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.788 12.736a.332.332 0 01.402.24l.697 2.71a.333.333 0 01-.643.166l-.495-1.93-3.78 5.879a.332.332 0 01-.552.009l-2.241-3.268-2.96 5.24a.333.333 0 01-.486.106l-3.268-2.393-3.138 3.487a.33.33 0 11-.493-.443l3.338-3.71a.332.332 0 01.442-.047l3.21 2.349 3.038-5.379c.057-.1.16-.163.275-.168.12.002.223.05.288.143l2.26 3.296 3.502-5.449-1.926.488a.332.332 0 01-.162-.644l2.692-.682z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.063 3.28a2.411 2.411 0 11.923 4.637 2.412 2.412 0 01-2.004-3.749 2.41 2.41 0 011.081-.888zm.923.505a1.724 1.724 0 00-1.721 1.722 1.721 1.721 0 101.721-1.722z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.943 1.278c3.867 0 7.013 3.145 7.013 7.011a7.018 7.018 0 01-3.874 6.267 6.257 6.257 0 01-2.014.654 7.02 7.02 0 01-8.137-6.92c0-3.867 3.146-7.011 7.012-7.012zm.03 7.906c-2.399 0-3.858 1.653-4.376 3.233.377.515.843 1.04 1.488 1.448.694.44 1.614.757 2.889.757a6.36 6.36 0 001.577-.191 6.31 6.31 0 00.752-.25 5.215 5.215 0 002.097-1.576c-.57-1.69-2.037-3.421-4.426-3.421zm-.03-7.243A6.356 6.356 0 002.595 8.29c0 1.472.505 2.827 1.35 3.905.587-1.762 2.249-3.677 5.029-3.677 2.682 0 4.313 1.864 4.997 3.641a6.314 6.314 0 001.321-3.869c0-3.5-2.848-6.348-6.349-6.348z","fill":"#fff"}})])
          )
        }
      }
    